import { Component } from '@angular/core';

@Component({
  selector: 'ui-fh-required-notes',
  templateUrl: './fh-required-notes.component.html',
  styleUrl: './fh-required-notes.component.scss'
})
export class FhRequiredNotesComponent {}
